import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const getMainLanguageDescription = (codeItem: CodeItem, mainLanguage: CodeComplexValue<number>) => {

  return !!codeItem && !!codeItem.description && !!mainLanguage
    ? codeItem.description.find(description => description.value === mainLanguage.value)
    : undefined;
};

export const getMainLanguageLongDescription = (codeItem: CodeItem, mainLanguage: CodeComplexValue<number>) => {

  return !!codeItem && !!codeItem.longDescription && !!mainLanguage
    ? codeItem.longDescription.find(description => description.value === mainLanguage.value)
    : undefined;
};
